import { openModal } from '@core/components/ModalStack';
import { ConvertProjectModalProps } from './ConvertProjectModal';

export async function openConvertProjectModal(props: ConvertProjectModalProps) {
  const { ConvertProjectModal } = await import('./ConvertProjectModal');

  openModal(ConvertProjectModal, props);
}
